<template>
  <section class="section section-shaped section-lg my-5">
    <div class="shape shape-style-none bg-darker">
      <!-- <div class="shape shape-style-1 bg-gradient-default"> -->
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <card
            type="dark"
            shadow
            header-classes="bg-white"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-center text-muted mb-4 h4">
                <small>Reset Password</small>
              </div>
              <form role="form">
                <base-input
                  alternative
                  class="mb-3 input-group-lg"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                ></base-input>
                <div class="text-center">
                  <base-button type="darker" class="my-4 btn-block">Send Reset link</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="/signin" class="text-light">
                <small>Sign In</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <a href="/signup" class="text-light">
                <small>Create new account</small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style>
</style>
